import { ShieldCheck, BadgeCheck, Heart, Truck, PackageCheck } from 'lucide-react';
import { TRUST_BADGES } from '../data/content';

const ICONS = { ShieldCheck, BadgeCheck, Heart, Truck, PackageCheck };

export default function TrustBar({ className = '', tone = 'light' }) {
  const isDark = tone === 'dark';
  return (
    <div data-testid="trust-bar" className={`${isDark ? 'bg-forest text-white' : 'bg-sand text-ink'} ${className}`}>
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-5">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {TRUST_BADGES.map(b => {
            const Icon = ICONS[b.icon] || ShieldCheck;
            return (
              <div key={b.label} className="flex items-center gap-2">
                <Icon size={18} className={isDark ? 'text-oat' : 'text-forest'} />
                <span className="font-manrope text-xs sm:text-sm font-medium">{b.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
